/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueTeam } from './LeagueTeam';
import {
    LeagueTeamFromJSON,
    LeagueTeamFromJSONTyped,
    LeagueTeamToJSON,
    LeagueTeamToJSONTyped,
} from './LeagueTeam';

/**
 * 
 * @export
 * @interface ApproveTeamResponse
 */
export interface ApproveTeamResponse {
    /**
     * 
     * @type {LeagueTeam}
     * @memberof ApproveTeamResponse
     */
    team: LeagueTeam;
    /**
     * 
     * @type {string}
     * @memberof ApproveTeamResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the ApproveTeamResponse interface.
 */
export function instanceOfApproveTeamResponse(value: object): value is ApproveTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function ApproveTeamResponseFromJSON(json: any): ApproveTeamResponse {
    return ApproveTeamResponseFromJSONTyped(json, false);
}

export function ApproveTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': LeagueTeamFromJSON(json['team']),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ApproveTeamResponseToJSON(json: any): ApproveTeamResponse {
    return ApproveTeamResponseToJSONTyped(json, false);
}

export function ApproveTeamResponseToJSONTyped(value?: ApproveTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': LeagueTeamToJSON(value['team']),
        'message': value['message'],
    };
}

